import React from 'react';

interface ToolModalProps {
  title: string;
  description: string;
  buttonText: string;
  onClose: (e: React.MouseEvent) => void;
  onAction: (e: React.MouseEvent) => void;
  isVisible: boolean;
}

const ToolModal: React.FC<ToolModalProps> = ({ title, description, buttonText, onClose, onAction, isVisible }) => {
  if (!isVisible) return null;

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation(); // Prevent click from reaching overlay
  };

  return (
    <div className="tool-modal" onClick={handleClick}>
      <button className="close-button" onClick={onClose}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      <h3 className="tool-modal-heading">{title}</h3>
      <p className="tool-modal-description">{description}</p>
      <button className="action-button" onClick={onAction}>
        {buttonText}
      </button>
    </div>
  );
};

export default ToolModal;
